import { PdfStrokeColor, PdfToolType, PdfTools } from './enums';
import { IToolStyles } from './interfaces';
import { hexToRgb } from '../common';
import { Core } from '@pdftron/webviewer';


export const PdfStrokeColors = [
  PdfStrokeColor.LightBlue,
  PdfStrokeColor.Blue,
  PdfStrokeColor.DarkBlue,
  PdfStrokeColor.LightGreen,
  PdfStrokeColor.Green,
  PdfStrokeColor.DarkGreen,
  PdfStrokeColor.Yellow,
  PdfStrokeColor.Orange,
  PdfStrokeColor.Red,
  PdfStrokeColor.Pink,
  PdfStrokeColor.Purple,
  PdfStrokeColor.DarkPurple,
  PdfStrokeColor.LightGray,
  PdfStrokeColor.Gray,
  PdfStrokeColor.Black
];

export type PdfShapeStyles = {
  [key in PdfToolType]?: IToolStyles;
};

export function getToolNameByType(type: PdfToolType): string {
  switch (type) {
    case PdfToolType.Rectangle:
      return PdfTools.AnnotationCreateRectangle;
    case PdfToolType.Ellipse:
      return PdfTools.AnnotationCreateEllipse;
    case PdfToolType.Arrow:
      return PdfTools.AnnotationCreateArrow;
    case PdfToolType.Line:
      return PdfTools.AnnotationCreateLine;
    case PdfToolType.FreeHand:
      return PdfTools.AnnotationCreateFreeHand;
    case PdfToolType.Marker:
      return PdfTools.AnnotationCreateTextHighlight;
    case PdfToolType.Default:
      return PdfTools.AnnotationEdit;
    case PdfToolType.Pan:
      return PdfTools.Pan;
    default: return '';
  }
}

export function createToolStylesFromShapeStyles(shapeStyles: IToolStyles) {
  if (shapeStyles.strokeColor) {
    return {
      StrokeColor: annotationColorFromHexColor(shapeStyles.strokeColor),
      StrokeThickness: shapeStyles.strokeThickness
    };
  }
}

export function annotationColorFromHexColor(color: string): Core.Annotations.Color {
  const rgbColor = hexToRgb(color);
  return new (window as any).Core.Annotations.Color(rgbColor.r, rgbColor.g, rgbColor.b, 1);
}
